<!--  -->
<template>
  <div class="guide-list fl-center">
    <template v-for="item in goodsList">
      <GoodsPanel class="guide-item" :key="item.id" v-bind="item" @handleTarget="handleTarget" />
    </template>
  </div>
</template>

<script>
import GoodsPanel from "../base/GoodsPanel.vue";
export default {
  components: { GoodsPanel },
  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      initialIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleChangeIndex(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    handleTarget(id) {
      this.$router.push(`/e-shop/good-info?id=${id}&type=${0}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.guide-list {
  .guide-item {
    margin-right: 30px;
  }
}
</style>
